import React, {Component} from 'react';
import {browserHistory} from 'react-router';
import {PATH_ADOPTAR, PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_ID,} from "../../../App/RouterAdopta";
import CardEntityListing from "./ListCards/CardEntityListing";
import {ADS_TYPES, AdsManagerContainer} from "../../Ads/components/AdsManagerContainer";


let ELEMENS_PER_ROW = 2;

class EntityList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showAnimalPreview: false,
            idAnimalPreview: 0,
            indexSelected: undefined,
            imageLoadedArray: []
        }


        this.onClickCard = this.onClickCard.bind(this);
        this.handleHide = this.handleHide.bind(this);
        this.handleHidePreview = this.handleHidePreview.bind(this);
    }


    onClickCard(idClick, index) {
        //console.log("EntityList::onClickCardListing()");
        //console.log("idClick = '" + idClick + "'");
        //console.log("index = '" + index + "'");
        this.props.onClickCard(idClick, index)
    }

    handleModify(idAnimal) {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_ID + idAnimal);
    }

    handleHide() {
        this.setState({
            ...this.state,
            indexSelected: undefined
        });
    }

    handleHidePreview() {
        // //console.log("no se que es esto")
        const {animalIdParam} = this.props;
        if (animalIdParam) {
            this.setState({
                idAnimalPreview: animalIdParam,
                showAnimalPreview: false,
                indexSelected: undefined
            });
        }

        if (this.props.animalsControl === "animals") {
            browserHistory.push(PATH_ADOPTAR);
        }
    }


    renderProtectoraList() {
        //console.log("EntityList::renderProtectoraList()");
        const elementsPerRow = this.props.config.elementsPerRow;
        const that = this;

        let adsUsed = 0
        return this.props.entities.list.map((protectora, index) => {
            const useAds = (!this.props.isRecomendationCards && ((index - 1) % 3 === 0))
            // const useAds = (!that.props.isRecomendationCards && ((index) % 2 === 0))
            const arrayAdsTypes = [ADS_TYPES.SPLITSCREEN, ADS_TYPES.ROBAPAGINAS, ADS_TYPES.MEGABANNER]
            let adType = arrayAdsTypes[(adsUsed % arrayAdsTypes.length)]
            if (useAds) adsUsed++

            return (
                <div className=""
                     style={{flex: ((100 / elementsPerRow) + "%"), maxWidth: ((100 / elementsPerRow) + "%")}}
                     key={"divCardInfo-" + protectora._id}>
                    <CardEntityListing
                        key={"cardInfo-" + protectora._id}
                        elementsPerRow={elementsPerRow}
                        entity={protectora}
                        isReady={true}
                        isRecomendationCards={this.props.isRecomendationCards}
                        index={index}
                        indexSelected={this.state.indexSelected}
                        onClickCard={this.onClickCard}
                        // imageLoaded={this.props.imageLoaded}
                        // imageError={this.props.imageError}
                        isAdminAnimals={this.props.isAdminAnimals}
                        currentElementHoverId={this.props.currentElementHoverId}
                        onMouseOverElement={this.props.onMouseOverElement}
                    />
                    {useAds && <AdsManagerContainer type={adType}/>}
                </div>
            );
        })
            .reduce(function (r, element, index) {
                if (index % elementsPerRow === 0) r.push([]);
                if (r[r.length - 1]) r[r.length - 1].push(element);
                return r;
            }, [])
            .map(function (rowContent, index) {
                // surround every group with 'row'
                return <div key={index}>
                    <div className="row" key={index}>{rowContent}</div>
                </div>;
            });
    }


    render() {
        return (
            <div>
                <div className="listing-houses">
                    {this.renderProtectoraList()}
                </div>
            </div>
        );
    }

    componentWillMount() {

    }

    componentDidMount() {


    }


    componentDidUpdate(prevProps, prevState, prevContext) {


    }

}


export default EntityList
